<h1 class="h3 mb-2 text-gray-800">Continuar con refinamiento</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Formulario de Refinamiento</h6>
    </div>
    <div class="card-body">
        <form>
            <app-planform [archivos]="archivos" [shouldPrepareInfo]="shouldPrepareInfo" [isAdmin]="isAdmin"
                [editable]="true" [isRefinamiento]="true" [planForm]="refinamiento"
                (onDataChanged)="onFormChanged($event)"></app-planform>
            <div class="row">
                <div class="col-4 offset-4">
                    <div class="form-group">
                        <label>Foto superior</label>
                        <div *ngIf="urlFotoSuperior"><img [src]="urlFotoSuperior" height="200"></div>
                        <div *ngIf="!urlFotoSuperior && archivoExiste('foto-superior')"><img
                                [src]="getFileUrl('foto-superior', 'jpg')" height="200"></div>

                        <input type="file" accept=".jpg, .jpeg, .png" #fileuploadTop="ngModel"
                            [(ngModel)]="fotoSuperior" name="fotoSuperior" (change)="seleccionaFotoSuperior($event)"
                            class="form-control" required />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <div class="form-group">
                        <label>Foto Lateral Der</label>
                        <div *ngIf="urlFotoDerecha"><img [src]="urlFotoDerecha" height="200"></div>
                        <div *ngIf="!urlFotoSuperior && archivoExiste('foto-derecha')"><img
                                [src]="getFileUrl('foto-derecha', 'jpg')" height="200"></div>

                        <input type="file" accept=".jpg, .jpeg, .png" #fileuploadRight="ngModel"
                            [(ngModel)]="fotoDerecha" name="fotoDerecha" required
                            (change)="seleccionarFotoDerecha($event)" class="form-control" />
                    </div>
                </div>
                <div class="col-4">
                    <div class="form-group">
                        <label>Frente intraoral</label>
                        <div *ngIf="urlFrenteIntraoral"><img [src]="urlFrenteIntraoral" height="200"></div>
                        <div *ngIf="!urlFotoSuperior && archivoExiste('frente-intraoral')"><img
                                [src]="getFileUrl('frente-intraoral', 'jpg')" height="200"></div>

                        <input type="file" accept=".jpg, .jpeg, .png" [(ngModel)]="frenteIntraoral"
                            #frenteIntraoralFU="ngModel" required name="frenteIntraoral"
                            (change)="seleccionaFrenteIntraoral($event)" class="form-control" />
                    </div>
                </div>
                <div class="col-4">
                    <div class="form-group">
                        <label>Foto Lateral Izq</label>
                        <div *ngIf="urlFotoIzquierda"><img [src]="urlFotoIzquierda" height="200"></div>
                        <div *ngIf="!urlFotoSuperior && archivoExiste('foto-izquierda')"><img
                                [src]="getFileUrl('foto-izquierda', 'jpg')" height="200"></div>

                        <input type="file" accept=".jpg, .jpeg, .png" #fileuploadLeft="ngModel"
                            [(ngModel)]="fotoIzquierda" name="fotoIzquierda" required
                            (change)="seleccionarFotoIzquierda($event)" class="form-control" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-4 offset-4">
                    <div class="form-group">
                        <label>Foto Inferior</label>
                        <div *ngIf="urlFotoInferior"><img [src]="urlFotoInferior" height="200"></div>
                        <div *ngIf="!urlFotoSuperior && archivoExiste('foto-inferior')"><img
                                [src]="getFileUrl('foto-inferior', 'jpg')" height="200"></div>

                        <input type="file" accept=".jpg, .jpeg, .png" #fileuploadBottom="ngModel"
                            [(ngModel)]="fotoInferior" name="fotoInferior" required
                            (change)="seleccionarFotoInferior($event)" class="form-control" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <div class="form-group">
                        <label>Frente facial</label>
                        <div *ngIf="urlFrenteFacial"><img [src]="urlFrenteFacial" height="200"></div>
                        <div *ngIf="!urlFotoSuperior && archivoExiste('frente-facial')"><img
                                [src]="getFileUrl('frente-facial', 'jpg')" height="200"></div>

                        <input type="file" accept=".jpg, .jpeg, .png" accept=".jpg, .jpeg, .png"
                            #frenteFacialFU="ngModel" [(ngModel)]="frenteFacial" required name="frenteFacial"
                            (change)="seleccionaFrenteFacial($event)" class="form-control" />
                    </div>
                </div>
                <div class="col-4">
                    <div class="form-group">
                        <label>Frente Facial Sonrisa</label>
                        <div *ngIf="urlFrenteFacialSonrisa"><img [src]="urlFrenteFacialSonrisa" height="200">
                        </div>
                        <div *ngIf="!urlFotoSuperior && archivoExiste('frente-facial-sonrisa')"><img
                                [src]="getFileUrl('frente-facial-sonrisa', 'jpg')" height="200"></div>

                        <input type="file" accept=".jpg, .jpeg, .png" accept=".jpg, .jpeg, .png"
                            #frenteFacialSonrisaFU="ngModel" [(ngModel)]="frenteFacialSonrisa"
                            name="frenteFacialSonrisa" (change)="seleccionaFrenteFacialSonrisa($event)" required
                            class="form-control" />
                    </div>
                </div>
                <div class="col-4">
                    <div class="form-group">
                        <label>Perfil Facial</label>
                        <div *ngIf="urlPerfilFacial"><img [src]="urlPerfilFacial" height="200"></div>
                        <div *ngIf="!urlFotoSuperior && archivoExiste('perfil-facial')"><img
                                [src]="getFileUrl('perfil-facial', 'jpg')" height="200"></div>

                        <input type="file" accept=".jpg, .jpeg, .png" accept=".jpg, .jpeg, .png"
                            #fotografiaPerfilFacialFU="ngModel" [(ngModel)]="fotografiaPerfilFacial" required
                            name="fotografiaPerfilFacial" (change)="seleccionaFotografiaPerfilFacial($event)"
                            class="form-control" />
                    </div>
                </div>
            </div>
            <div class="form-group">
                <p><b>Nota.-</b> La revisión de los datos tarda aproximadamente 2 semanas.<br> si hubiera un
                    inconveniente se le notificará lo más pronto posible.</p>
            </div>
            <div class="form-group">
                <ng-container
                    *ngIf="isAdmin && refinamiento.status == estadosRefinamiento.FORMULARIO_REFINAMIENTO_ENVIADO">
                    <button type="submit" class="btn btn-success"
                        (click)="openSolicitarAprobacion(aprobacionModal)">Aprobar
                        refinamiento</button>&nbsp;
                </ng-container>
                <button type="submit" class="btn btn-primary" (click)="guardarDatos()">Guardar Datos</button>&nbsp;
                <ng-container *ngIf="refinamiento.status != estadosRefinamiento.FORMULARIO_REFINAMIENTO_ENVIADO">
                    <button type="submit" class="btn btn-success" (click)="solicitarTratamiento()">Confirmar y solicitar
                        refinamiento</button>&nbsp;
                </ng-container>
                <a [routerLink]="'/casos/'+refinamiento.caso_id+'/verpaciente'" class="btn btn-link">Volver</a>

            </div>
        </form>
    </div>
</div>
<ng-template #aprobacionModal let-modal>
    <form name="form" (ngSubmit)="f2.form.valid && enviarAprobacion()" #f2="ngForm">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Aprobación y presupuesto</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">

            <div class="form-group">
                <label for="precioTratamientoBs">Ingrese el monto del presupuesto en Bs:</label>
                <input type="number" class="form-control" name="precioTratamientoBs" id="precioTratamientoBs" required
                    #precioTratamientoBs="ngModel"
                    [ngClass]="{'is-invalid':  f2.submitted && precioTratamientoBs.invalid}"
                    [(ngModel)]="refinamiento.precio_tratamiento_bs" />
                <div *ngIf="f2.submitted && precioTratamientoBs.invalid" class="invalid-feedback">
                    <div *ngIf="precioTratamientoBs.errors.required">El precio es requerido</div>
                </div>
            </div>
            <div class="form-group">
                <label>Enviar PDF de resultados</label>
                <input type="file" #fileuploadTop="ngModel" [(ngModel)]="pdf" name="pdf" accept=".pdf"
                    (change)="seleccionarPdf($event)" class="form-control"
                    [ngClass]="{'is-invalid':  f2.submitted && fileuploadTop.invalid}" required />
                <div *ngIf="f2.submitted && fileuploadTop.invalid" class="invalid-feedback">
                    <div *ngIf="fileuploadTop.errors.required">El PDF es requerido</div>
                </div>
            </div>
            <div class="form-group">
                <label for="videoYoutube">URL del Video en Youtube</label>
                <input class="form-control" name="videoYoutube" #videoYoutube="ngModel"
                    [ngClass]="{'is-invalid':  f2.submitted && videoYoutube.invalid}"
                    [(ngModel)]="refinamiento.video_entrega" />
                <div *ngIf="f2.submitted && videoYoutube.invalid" class="invalid-feedback">
                    <div *ngIf="videoYoutube.errors.required">La URL del video es requerida</div>
                </div>
            </div>
            <!-- <div class="form-group">
                <label for="reunionZoom">Datos de la reunión de zoom</label>
                <textarea class="form-control" name="reunionZoom" #reunionZoom="ngModel"
                    [ngClass]="{'is-invalid':  f2.submitted && reunionZoom.invalid}" style="width: 100%; height: 150px;"
                    [(ngModel)]="refinamiento.reunionZoom"></textarea>
                <div *ngIf="f2.submitted && reunionZoom.invalid" class="invalid-feedback">
                    <div *ngIf="reunionZoom.errors.required">Los datos de la reunión de zoom son requeridos</div>
                </div>
            </div> -->
        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-outline-dark">Enviar aprobación</button>
        </div>
    </form>
</ng-template>